/**
 * 시도별 정답률 차트 컴포넌트
 * Recharts LineChart를 사용하여 1차, 2차, 3차 시도별 정답률 표시
 */

import React from 'react';
import { Card } from 'antd';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { AttemptStatItem } from '../../types/stats';

interface AttemptAccuracyChartProps {
  attempts: AttemptStatItem[];
  loading?: boolean;
}

export const AttemptAccuracyChart: React.FC<AttemptAccuracyChartProps> = ({
  attempts,
  loading = false,
}) => {
  // 차트 데이터 변환
  const chartData = attempts.map((attempt) => ({
    name: `${attempt.attempt_number}차 시도`,
    attempt_number: attempt.attempt_number,
    정답률: attempt.accuracy,
    정답수: attempt.correct_problems,
    문제수: attempt.total_problems,
  }));

  return (
    <Card title="시도별 정답률" loading={loading}>
      {chartData.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '40px 0', color: '#999' }}>
          데이터가 없습니다
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={300}>
          <LineChart
            data={chartData}
            margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis
              domain={[0, 100]}
              label={{ value: '정답률 (%)', angle: -90, position: 'insideLeft' }}
            />
            <Tooltip
              formatter={(value: number, name: string) => {
                if (name === '정답률') {
                  return [`${value.toFixed(1)}%`, name];
                }
                return [value, name];
              }}
            />
            <Legend />
            <Line
              type="monotone"
              dataKey="정답률"
              stroke="#1890ff"
              strokeWidth={2}
              activeDot={{ r: 8 }}
            />
          </LineChart>
        </ResponsiveContainer>
      )}
    </Card>
  );
};
